import { useContext } from 'react'
import { useRestQuery } from '@/lib/hook/tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'
import ProfileContext from '@/components/Context/ProfileContext'

export type WishlistProduct = {
  product_id: string
  product: string
  price: string
  main_pair?: any
  image_pairs?: any[]
  seo_name?: string
  amount: number
  display_amount: number
  item_id?: string
  product_code?: string
  cart_id?: string
  brand_name?: string
}

type WishlistResponse = {
  products: Record<string, WishlistProduct> | WishlistProduct[]
}

export const toWishlistArray = (products: Record<string, WishlistProduct> | WishlistProduct[] | undefined): WishlistProduct[] => {
  if (!products) return []
  if (Array.isArray(products)) return products
  return Object.entries(products).map(([key, product]) => ({
    ...product,
    cart_id: key,
  }))
}

export const useWishlistIds = () => {
  const { isAuthenticated } = useContext(ProfileContext)

  const query = useRestQuery<WishlistResponse, Error, WishlistProduct[]>({
    ...ApiQueryEndpoint.USERS.GET_WISHLIST,
    queryKey: ['wishlist'],
    enabled: isAuthenticated,
    select: (data) => toWishlistArray(data?.products),
    staleTime: 1000 * 60 * 5,
  })

  const items = query.data ?? []

  return {
    wishlistIds: items.map((p) => p.product_id),
    isLoading: query.isLoading,
    isInWishlist: (productId: string) => items.some((p) => String(p.product_id) === String(productId)),
    getCartId: (productId: string) => items.find((p) => String(p.product_id) === String(productId))?.cart_id,
  }
}
